export default function PageNotFound() {
  return (
    <div className="flex items-center flex-col justify-center w-full h-full">
      <h1 className="text-4xl font-bold mb-2">404</h1>
      <h2 className="text-lg mb-1">Page Not Found</h2>
      <a className="link" href="/">Home</a>
    </div>
  );
}